import { createElement, useEffect, useMemo, useState } from 'react'
import { useLocaleState, useResourceDefinitions } from 'react-admin'
import NavSection from './NavSection'
import { usePermissionProvider } from '../../contexts/rbac-context'
import MenuIcon from '@mui/icons-material/Menu'
import { configT } from './type'
import { orderBy } from 'lodash'
import { MenuPermission } from '../../utils/menu/type'
import DashboardIcon from '@mui/icons-material/Dashboard'

const SideNav = (): JSX.Element => {
  const resources = useResourceDefinitions()
  const { menuConfig } = usePermissionProvider()
  const [activeLocale] = useLocaleState()
  const [configMenu, setConfigMenu] = useState<configT[]>([])
  const buildConfig = useMemo(() => {
    const extraMenu = [
      {
        title: activeLocale == 'th' ? 'แดชบอร์ด' : 'Dashboard',
        path: '/',
        icon: <DashboardIcon />,
        order: 0,
      },
    ]

    const config: configT[] = menuConfig
      .filter(
        (menu: MenuPermission) => resources[menu.resourceName.resource] || menu.childs.length != 0,
      )
      .map((menu, i) => {
        const { resourceName, title } = menu
        const sortedChildren = orderBy(menu.childs, 'order', 'asc')

        const children = sortedChildren.map((child, j) => {
          return {
            title: child.title?.[activeLocale],
            path: child.resourceName.resource ? `/${child.resourceName.resource}` : '/not-found',
            icon: resources[child.resourceName.resource]?.icon ? (
              createElement(resources[child.resourceName.resource]?.icon)
            ) : (
              <MenuIcon />
            ),
            order: j + 1,
          }
        })

        return {
          title: title?.[activeLocale],
          path: resourceName.resource ? `/${resourceName.resource}` : '#',
          icon: resources[resourceName.resource]?.icon ? (
            createElement(resources[resourceName.resource]?.icon)
          ) : (
            <MenuIcon />
          ),
          order: i + 1,
          children: children.length > 0 ? children : undefined,
        }
      })

    config.push(...extraMenu)
    const sortedMenuConfig = orderBy(config, 'order', 'asc')
    return sortedMenuConfig
  }, [menuConfig, resources, activeLocale])

  useEffect(() => {
    setConfigMenu(buildConfig)
  }, [buildConfig])
  return <NavSection navConfig={configMenu} />
}

export default SideNav
